export const LIVELLO = { 1: "Fondamenta", 2: "Sviluppi", 3: "Vette", 4: "L'Officina del Vivere" };

export const LEGAL_TEXT =
  "Bottega di Filosofia è un percorso formativo privato di divulgazione e studio. " +
  "Non è un'università, non rilascia titoli di studio, lauree, CFU o certificazioni riconosciute. " +
  "Le lezioni e le prove sono generate con sapienza umana e supporto intelligenza artificiale.";

export const RARITA_STYLE = {
  Bronzo: "bg-[#a97142] text-white",
  Argento: "bg-[#9aa0a6] text-white",
  Oro: "bg-accent text-accent-foreground",
  Olografica: "bg-gradient-to-r from-fuchsia-500 via-primary to-amber-400 text-white",
};

export const examLabel = (courseId) => (courseId === "erm" ? "Il Capolavoro" : "Prova del Maestro");
